import { render, staticRenderFns } from "./registroSintesi.html?vue&type=template&id=5a6d3870&external"
import script from "./RegistroSintesi.vue?vue&type=script&lang=js"
export * from "./RegistroSintesi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports